import { cureBayContentTypes } from "../types";
const initialState = {
    status: false,
    loading: false,
    error: ""
}
const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case cureBayContentTypes.FETCH:
            return { ...state, loading: true }
        case cureBayContentTypes.SUCCESS:
            return { ...state, status: payload, loading: false, error: "", }
        case cureBayContentTypes.ERROR:
            return { ...state, loading: false, error: payload }
        case cureBayContentTypes.RESET:
            return initialState;
        default:
            return state;
    }
}

export default reducer;